<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    round
    closeable
    class="p-6 w-full"
  >
    <div class="text-base-content">
      <div class="mb-4">
        <div class="font-bold text-lg mb-2">
          {{ $t("interactive.house.setting.name") }}
        </div>
        <div class="flex items-center justify-between mb-3">
          <span>{{ $t("interactive.house.setting.allowWandering") }}</span>
          <VanSwitch
            :model-value="userStore.user.canRequestStroll"
            size="14"
            :loading="requestStrollLoading"
            @change="updateUser('canRequestStroll')"
          />
        </div>
        <div class="flex items-center justify-between mb-3">
          <span>{{ $t("interactive.house.setting.allowWrite") }}</span>
          <VanSwitch
            :model-value="userStore.user.canRequestLetterSending"
            size="14"
            :loading="requestLetterSendingLoading"
            @change="updateUser('canRequestLetterSending')"
          />
        </div>
        <div class="flex items-center justify-between mb-3">
          <span>{{ $t("interactive.house.setting.allowPostMoment") }}</span>
          <VanSwitch
            :model-value="userStore.user.canRequestMomentPost"
            size="14"
            :loading="requestMomentPostLoading"
            @change="updateUser('canRequestMomentPost')"
          />
        </div>
        <div class="flex items-center justify-between mb-3">
          <span>{{ $t("interactive.house.setting.allowCommentMoment") }}</span>
          <VanSwitch
            :model-value="userStore.user.canRequestMomentComment"
            size="14"
            :loading="requestMomentCommentLoading"
            @change="updateUser('canRequestMomentComment')"
          />
        </div>
        <!-- <div class="flex items-center justify-between">
          <span>{{ $t("interactive.house.setting.keepRunning") }}</span>
          <VanSwitch v-model="keepRunning" size="14" />
        </div> -->
      </div>
      <div>
        <div class="font-bold text-lg mb-2">
          {{ $t("interactive.house.consumption.name") }}
        </div>
        <div class="mb-1">
          <div class="flex items-center gap-1">
            {{ $t("interactive.house.consumption.future") }}
            <PowerIcon />
            {{
              userStore.getPowerCostByModel(
                interactiveStore.estimatedPowerCubes || 0
              )
            }}

            <SelectModelBtn />
          </div>
        </div>
        <div class="text-xs text-gray-500">
          {{ $t("interactive.house.consumption.note") }}
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useGlobalUser } from "@/stores/globalUser";
import { User } from "@/types/entity";
import { ref } from "vue";
import { useInteractive } from "@/stores/interactive";
defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
}>();

const userStore = useGlobalUser();
const interactiveStore = useInteractive();
const requestStrollLoading = ref(false);
const requestLetterSendingLoading = ref(false);
const requestMomentPostLoading = ref(false);
const requestMomentCommentLoading = ref(false);
const updateUser = async (type: keyof User) => {
  if (type === "canRequestStroll") {
    requestStrollLoading.value = true;
    await userStore.updateUserApi({
      canRequestStroll: !userStore.user.canRequestStroll,
    });
    requestStrollLoading.value = false;
  }
  if (type === "canRequestLetterSending") {
    requestLetterSendingLoading.value = true;
    await userStore.updateUserApi({
      canRequestLetterSending: !userStore.user.canRequestLetterSending,
    });
    requestLetterSendingLoading.value = false;
  }
  if (type === "canRequestMomentPost") {
    requestMomentPostLoading.value = true;
    await userStore.updateUserApi({
      canRequestMomentPost: !userStore.user.canRequestMomentPost,
    });
    requestMomentPostLoading.value = false;
  }
  if (type === "canRequestMomentComment") {
    requestMomentCommentLoading.value = true;
    await userStore.updateUserApi({
      canRequestMomentComment: !userStore.user.canRequestMomentComment,
    });
    requestMomentCommentLoading.value = false;
  }
  await interactiveStore.getPoolList();
};

// const allowSuDa = ref(true);
// const allowWrite = ref(true);
// const keepRunning = ref(false);
</script>

<style scoped>
/* 可根据 daisyUI 主题自定义样式 */
</style>
